import { render, staticRenderFns } from "./LetterTemplateItem.vue?vue&type=template&id=2456c282&"
import script from "./LetterTemplateItem.vue?vue&type=script&lang=ts&"
export * from "./LetterTemplateItem.vue?vue&type=script&lang=ts&"
import style0 from "./LetterTemplateItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports